import React, {useEffect} from "react";
import styles from "./FranchisesTab.module.css";
import {Button, ButtonState} from "../../../elements/button/Button";
import {useAppDispatch} from "../../../../app/hooks";
import {FormName, openForm} from "../../../elements/formProvider/formSlice";
import {MenuItem, updateSelectedMenuItem} from "../../platform/platformSlice";
import {FranchiseTable} from "./FranchiseTable";

export const FranchisesTab: React.FC = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(updateSelectedMenuItem(MenuItem.FRANCHISES));
    }, [dispatch]);

    const openCreate = () => dispatch(openForm({name: FormName.CREATE_FRANCHISE}));

    return <div className={styles.wrapper}>
        <div className={styles.headerSectionWrapper}>
            <span className={styles.title}>Franchises</span>
            <Button
                title={"Create franchise"}
                iconSrc={"/plusIcon.svg"}
                state={ButtonState.PRIMARY}
                handleClick={openCreate}
            />
        </div>
        <FranchiseTable/>
    </div>;
};
